import * as React from 'react';
import * as Autosuggest from "react-autosuggest";
import { _ } from "@src/services/i18n";
import {
  classNames,
  css,
  mixin,
  vars,
  defaultProps,
  formatters
} from "@src/services/theme";
import { Proto, Props, State } from "@src/components/Proto";
import { LoadingMini } from "@src/components";

// typing
interface LocalProps extends Props {
    id?: string;
    searchID?: string;
    placeholder?: string;
    onChange?: Function;
}

interface LocalState extends State {
    isLoading: boolean;
    value?: any;
    suggestions?: any;
}

// style
const style = css`
    position: relative;
    ._loading {
        position: absolute;
        z-index: 2;
        right: 10px;
        top: 10px;
    }
    .react-autosuggest__container {
        position: relative;
        text-align: left;
    }

    .react-autosuggest__input {
    width: 240px;
    height: 30px;
    padding: 10px 20px;
    font-family: Helvetica, sans-serif;
    font-weight: 300;
    font-size: 16px;
    border: 1px solid #aaa;
    border-radius: 4px;
    }

    .react-autosuggest__input--focused {
    outline: none;
    }

    .react-autosuggest__input--open {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    }

    .react-autosuggest__suggestions-container {
    display: none;
    }

    .react-autosuggest__suggestions-container--open {
    display: block;
    position: absolute;
    top: 38px;
    width: 100%;
    border: 1px solid #e5e5e5;
    background-color: #fff;
    font-family: Helvetica, sans-serif;
    font-weight: 300;
    font-size: 16px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    z-index: 2;
    }

    .react-autosuggest__suggestions-list {
    margin: 0;
    padding: 0;
    list-style-type: none;
    }

    .react-autosuggest__suggestion {
    cursor: pointer;
    padding: 10px 20px;
    }

    .react-autosuggest__suggestion--highlighted {
    background-color: #ddd;
    }
`;



// component
var lastRequestId;
export class FastSearch extends Proto<LocalProps, LocalState> {
    state = {
        value: "",
        isLoading: false
    } as LocalState;

    onChange = (event, { newValue }) => {
        this.setState({
            value: newValue
        });
    };

    getSuggestions = (value) => {
        // Cancel the previous request
        if (lastRequestId !== null) {
            clearTimeout(lastRequestId);
        }
        this.setState({
            isLoading: true
        });
        lastRequestId = setTimeout(async () => {
            const inputValue = value.trim().toLowerCase();
            const inputLength = inputValue.length;
            const res = await this.loadCptData( "search", {
                q: inputValue
            } );
            const suggestions = (res as any).data.data;
            this.setState({
                isLoading: false,
                suggestions
            });
        }, 300);
    };
        
    getSuggestionValue = suggestion => suggestion.label;
        
    renderSuggestion = suggestion => (
        <div>
            {suggestion.label}
        </div>
    );

    // Autosuggest will call this function every time you need to update suggestions.
    // You already implemented this logic above, so just use it.
    onSuggestionsFetchRequested = ({ value }) => {
        this.getSuggestions(value);
    };

    // Autosuggest will call this function every time you need to clear suggestions.
    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };

    selectItem = (e, {suggestion}) => {
        const { searchID = "id", onChange } = this.props;
        if (onChange) {
            onChange( { [searchID]: suggestion.id } );
        }
    }

    // render
    render() {
        const { id = "q", placeholder } = this.props;
        const { data, value, suggestions= [], isLoading } = this.state;

        const inputProps = {
            className: "form-control",
            placeholder: (placeholder || _('search_placeholder')),
            value,
            onChange: this.onChange
        } as any;

        return (
        <div className={style}>
            {isLoading &&
            <span className="_loading"><LoadingMini /></span>
            }
            <Autosuggest
                id={id}
                suggestions={suggestions}
                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                getSuggestionValue={this.getSuggestionValue}
                renderSuggestion={this.renderSuggestion}
                inputProps={inputProps}
                onSuggestionSelected={this.selectItem}
            />
        </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Common/FastSearch.tsx